import * as React from 'react';
import { Col, Row } from 'antd';

import { CardController } from 'src/app/shared/card.controller';
import { InputWithRetypeView } from 'src/core/ui/password-creation';

interface Props extends ComponentViewProps<UserItem> {
	mode: ControlMode;
	operation: 'new' | 'update';
}

interface State {
	passwordFirstChanged: boolean;
	retypedPassword: string;
}

export class UserCredentialsView extends React.Component<Props, State> {
	constructor(props: Readonly<Props>) {
		super(props);

		this.state = {
			passwordFirstChanged: false,
			retypedPassword: this.props.model.password
		};
	}

	handlePasswordFirstChange = (newVal: string) => {
		this.props.model.password = newVal;
		this.setState({
			passwordFirstChanged: true
		});
		this.props.model['passwordChanged'] = true;
	}

	handlePasswordRetyped = (newVal: string) => {
		this.props.model['retypedPassword'] = newVal;
		this.setState({
			passwordFirstChanged: true
		});
		this.props.model['passwordChanged'] = true;
	}

	render() {
		const model = this.props.model;
		const required = this.state.passwordFirstChanged || this.props.operation == 'new';

		return (
			<CardController
				className="card-borderless"
				mode={this.props.mode}
				icon="lock"
				title="User credentials">
				<Row>
					<Col xs={24}>
						<InputWithRetypeView
							value2={this.props.model['retypedPassword']}
							onChange2={this.handlePasswordRetyped}
							onChange1={this.handlePasswordFirstChange}
							required={required}
							label="New Password"
							relabel="Retype Password"
							type="password"
							value1={this.props.model.password}
							mode={this.props.mode}
						/>
					</Col>
				</Row>
			</CardController>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/general/users/form/parts/usercredentials-form.view.tsx